module.exports = __webpack_public_path__ + "static/media/open-engine-graph1.ba78d10e.png";